__turbopack_context__.v({
  "active": "tabs-module-scss-module__sIb2xG__active",
  "badge": "tabs-module-scss-module__sIb2xG__badge",
  "icon": "tabs-module-scss-module__sIb2xG__icon",
  "stackOnTablet": "tabs-module-scss-module__sIb2xG__stackOnTablet",
  "stretch": "tabs-module-scss-module__sIb2xG__stretch",
  "tab": "tabs-module-scss-module__sIb2xG__tab",
  "tabs": "tabs-module-scss-module__sIb2xG__tabs",
});
